import { ISwapResolvedMessage } from '../../components';
import { INFT } from '../../types/nft';
import { RootState } from '../store';
import { AnswerSwapStep, AppState, CreateSwapStep } from './slice';
import { ISwap } from '../../types/swap';
import { Routes } from '../../constants/routes';

export const selectAppState = (state: RootState): AppState => state.app.appState;

export const selectCreateSwapStep = (state: RootState): CreateSwapStep => state.app.createSwapStep;

export const selectAnswerSwapStep = (state: RootState): AnswerSwapStep => state.app.answerSwapStep;

export const selectActiveSwap = (state: RootState): ISwap | undefined => state.app.activeSwap;

export const selectSelectedNFTs = (state: RootState): INFT[] => state.app.selectedNFTs.NFTs;

export const selectIsEthInputOpen = (state: RootState): boolean => state.app.selectedNFTs.eth.isInputOpen;

export const selectEnteredEthAmount = (state: RootState): number | undefined => state.app.selectedNFTs.eth.amount;

export const selectRecipient = (state: RootState): string | undefined => state.app.recipient;

export const selectSwapResolvedData = (state: RootState): ISwapResolvedMessage => state.app.swapResolvedData;

export const getEthPrice = (state: RootState): string => {
  return state?.app?.ethPrice ?? 'nope';
};

export const selectWalletDropdownOpen = (state: RootState): boolean => state.app.walletDropdownOpen;
export const selectRedirectRouteAfterLoginSuccess = (state: RootState): Routes =>
  state.app.redirectRouteAfterLoginSuccess;
